import { defineTour } from '@/shared/tour';

export const INVOICE_HOME_TOUR = defineTour({
  id: 'invoice_v2_home',
  version: 1,
  startDelayMs: 3000,
  steps: [
    {
      anchor: 'invoice-home-search',
      title: 'Empieza por tu cliente',
      body: 'Búscalo por nombre o RFC, o elige uno de tus recientes. Con eso arranca tu factura.',
    },
    {
      anchor: 'invoice-assistant',
      title: 'Pregúntale al asistente',
      body: 'Cuéntale qué vendiste y te arma el borrador platicando. Tú revisas antes de timbrar.',
    },
    {
      anchor: 'invoice-home-qr',
      title: 'Tu página de facturación',
      body: 'Con tu QR, tus clientes piden su factura solos y tú solo la apruebas.',
    },
  ],
});

export const INVOICE_CONCEPTS_TOUR = defineTour({
  id: 'invoice_v2_concepts',
  version: 1,
  steps: [
    {
      anchor: 'invoice-concepts-gross-up',
      title: 'Escribe lo que quieres recibir',
      body: 'Con esto encendido calculamos el IVA y las retenciones hacia atrás, para que te llegue exactamente el monto que escribiste.',
    },
  ],
});

export const INVOICE_QR_PAGE_TOUR = defineTour({
  id: 'invoice_v2_qr_page',
  version: 1,
  steps: [
    {
      anchor: 'invoice-qr-configure',
      title: 'Configura tu página',
      body: 'Aquí cambias el nombre de tu negocio, tus datos de emisor y los productos que ven tus clientes.',
    },
    {
      anchor: 'invoice-qr-share',
      title: 'Comparte tu QR',
      body: 'Descárgalo para imprimirlo o compártelo directo. Tus clientes lo escanean y piden su factura.',
    },
    {
      anchor: 'invoice-qr-requests',
      title: 'Aquí llegan las solicitudes',
      body: 'Toca una para revisarla. La apruebas o le pides correcciones antes de timbrar.',
    },
  ],
});
